module.exports = __webpack_public_path__ + "static/media/checkbox_off.1bcdcbb6.svg";